export const isEvaluationAnswerPath = (pathname: string): boolean =>
  pathname.split('/')[2]?.toLowerCase() === 'utvardering';
